import React, { useState } from "react";
import { imguser } from "../../imagepath";
import Breadcrumb from '../../ui/Breadcrumb';
import { useAuth } from '../../../contexts/AuthContext';
import { authService } from '../../../services/authService';

const EditProfile = () => {
  const { user, refreshUser } = useAuth();

  const [name, setName] = useState(user?.name || '');
  const [lastname, setLastname] = useState(user?.lastname || '');
  const [email, setEmail] = useState(user?.email || '');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!user?.id) {
      setError('No se pudo determinar el usuario actual.');
      return;
    }

    setLoading(true);
    try {
      await authService.updateMe({ name, lastname, email });
      await refreshUser();
      setSuccess(true);
    } catch (err) {
      setError(err?.response?.data?.message || 'Error al actualizar el perfil.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <Breadcrumb items={[{ label: 'Inicio', to: '/' }, { label: 'Editar Perfil' }]} />
          </div>
        </div>
      </div>
      {/* /Page Header */}
      <form onSubmit={handleSubmit}>
        {success && (
          <div className="alert alert-success" role="alert">
            <i className="fa fa-check-circle me-2"></i>
            Perfil actualizado correctamente.
          </div>
        )}
        {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}
        <div className="card">
          <div className="card-body">
            <h3 className="card-title">Información Básica</h3>
            <div className="row">
              <div className="col-md-12">
                <div className="profile-img-wrap">
                  <img className="inline-block" src={imguser} alt="user" />
                </div>
                <div className="profile-basic">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group local-forms">
                        <label className="focus-label">Nombre</label>
                        <input
                          type="text"
                          className="form-control floating"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group local-forms">
                        <label className="focus-label">Apellido</label>
                        <input
                          type="text"
                          className="form-control floating"
                          value={lastname}
                          onChange={(e) => setLastname(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <h3 className="card-title">Información de Contacto</h3>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group local-forms">
                  <label className="focus-label">Correo Electrónico</label>
                  <input
                    type="email"
                    className="form-control floating"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center m-t-20">
          <button className="btn btn-primary submit-btn" type="submit" disabled={loading}>
            {loading
              ? <><i className="fa fa-spinner fa-spin me-2"></i>Guardando...</>
              : 'Guardar'
            }
          </button>
        </div>
      </form>
    </>
  );
};

export default EditProfile;
